import { createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3eda27e9")

_pushScopeId("data-v-3eda27e9")
const _hoisted_1 = { id: "entire_notification_side" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title_container\" data-v-3eda27e9><div class=\"title_name\" data-v-3eda27e9><h6 data-v-3eda27e9>Notification center</h6></div><div class=\"all_feed\" data-v-3eda27e9><p data-v-3eda27e9>All feeds</p></div></div><div class=\"notifications\" data-v-3eda27e9><img style=\"margin-bottom:0.5em;\" src=\"https://img.icons8.com/color/48/000000/where-what-quest.png\" data-v-3eda27e9><span style=\"font-size:0.7em !important, opacity: 0.7 !important;\" data-v-3eda27e9>Oops! No notifications yet.</span></div>", 2)
const _hoisted_4 = { class: "calendar" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_calendar = _resolveComponent("calendar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_calendar)
    ])
  ]))
})